import { useEffect, useState } from "react";

export type Route = { kind: "landing" } | { kind: "list" } | { kind: "doc"; id: string };

const DOC_ID_RE = /^[a-z0-9-]+$/u;

export function parseRoute(hash: string): Route {
  const trimmed = hash.replace(/^#\/?/u, "");
  if (trimmed === "" || trimmed === "/") return { kind: "landing" };
  if (trimmed === "list") return { kind: "list" };
  if (DOC_ID_RE.test(trimmed)) return { kind: "doc", id: trimmed };
  return { kind: "landing" };
}

export function routeToHash(route: Route): string {
  switch (route.kind) {
    case "landing":
      return "#/";
    case "list":
      return "#/list";
    case "doc":
      return `#/${route.id}`;
  }
}

export function navigateTo(route: Route): void {
  const hash = routeToHash(route);
  if (location.hash !== hash) {
    location.hash = hash;
  }
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => parseRoute(location.hash));
  useEffect(() => {
    const handler = (): void => setRoute(parseRoute(location.hash));
    window.addEventListener("hashchange", handler);
    return () => window.removeEventListener("hashchange", handler);
  }, []);
  return route;
}
